<template>
<div>
  <Table :context="self" :data="tableData" :columns="tableColumns" stripe border></Table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
                <Page :total="total" :current="page" @on-change="changePage" :page-size="pagesize" show-total></Page>
            </div>
        </div>
</div>
</template>
<script>
import { adminlog } from '../../api/adminapi'
export default {
  data() {
    return {
        self: this,
      tableData: [],
      page: 1,
      pagesize: 10,
      total: null,
      id:null,
      tableColumns: [
        {
          title: "时间",
          key: "time",
          align: "center"
        },
        {
          title: "操作内容",
          key: "content",
          align: "center"
        },
        {
          title: "浏览器信息",
          key: "ua",
          align: "center"
        },
        {
          title: "IP地址",
          key: "ip",
          align: "center"
        }
      ]
    };
  },
  methods: {
    adminlog() {
      var para = {
        page: this.page,
        pagesize: this.pagesize,
        id: this.id
      };
      adminlog(para).then(res => {
        this.$Loading.finish();
        var Data = res.data;
        this.total = Data.data.total;
        this.tableData = Data.data.data;
      });
    },
  changePage(row) {
      this.page = row;
      this.adminlog();
    }
  },
  mounted(){
      if(this.$route&&this.$route.query){
          this.id=this.$route.query.id
          this.adminlog()
      }

  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/Adminlog.vue